/*
* Typeahead used for campaign search
*/

(() => {
  angular
    .module('adtDirectives')
    .directive('typeahead', () => (
      (scope, el, attr) => {
        const parent = el.parent();
        parent.click(e => {
          parent.addClass('focus');
          e.stopPropagation();
        });

        $('body').on('click', () => {
          parent.removeClass('focus');
        });

        const source = new Bloodhound({
          datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
          queryTokenizer: Bloodhound.tokenizers.whitespace,
          identify: ({name}) => {
            console.log('identity', name);
            return name;
          },
          remote: {
            url: '/campaign/search?q=%QUERY',
            wildcard: '%QUERY'
          }
        });

        el.typeahead({
          highlight: true, // Higlight entered in suggestion
          hint: false // Do not add first suggestion to input
        }, {
          source,
          limit: 15,
          display: ({name}) => name, // Controls value set to input on selecting value
          templates: {
            empty: `
              <div class="tt-empty-message">
                Unable to find any campaigns that match the current query
              </div>`,
            suggestion: ({ pid, id, name, labels, referenceId }) => (`
              <a href="/report/${pid || id}" style="display: block">
                <h3>${name}</h3>
                ${labels ? labels.map(label => `<span class="label-box">${label.name}</span>`) : ''}
                ${referenceId ? `<span class="label-box">${referenceId}</span>` : ''}
              </a>`),
          }
        })
        .on('typeahead:select', (event, { pid, id }) => {
          window.location.href = `/report/${pid || id}`;
        })
        .on('typeahead:asyncrequest', () => {
          $('#search-icon').hide();
          $('#search-loader').show();
        }).on('typeahead:asynccancel typeahead:asyncreceive', () => {
          $('#search-icon').show();
          $('#search-loader').hide();
        });
      }
    ));
})();
